import React from "react";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import MenuItem from '@material-ui/core/MenuItem';
import {Link} from "react-router-dom";
import ListItemText from "@material-ui/core/ListItemText";

import {apollo_useStyles} from "../atom/Apollo_styles";

export const ApolloLinkDialog: React.FC<{ handleLink: (num:number) => void, title?: string, text?: string, modaltext: string, disabled?: boolean, num?: number, close?: any, readonly?: boolean }> = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const classes = apollo_useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const label = props.title ? props.title : "未設定";
  const text = props.text + "しますか？";
  const title = props.modaltext ? props.modaltext + props.text : "";
  const num = props.num ? props.num : 0;

  return (
    <React.Fragment>
      
      {!props.readonly && (
      <Link
        to={"#"}
        onClick={handleClickOpen}
        className={classes.link}
      >
        <MenuItem onClick={props.close}>
          <ListItemText primary={label}/>
        </MenuItem>
      </Link>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              handleClose();
              props.handleLink(num);
            }}
            color="primary"
            autoFocus
          >
            {props.text}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}